/* eslint-disable */

import React from 'react'
import { createScope, map, transformProxies } from './helpers'

const scripts = [

]

let Controller

class BottomNavbarView extends React.Component {
  static get Controller() {
    if (Controller) return Controller

    try {
      Controller = require('../controllers/BottomNavbarController')
      Controller = Controller.default || Controller

      return Controller
    }
    catch (e) {
      if (e.code == 'MODULE_NOT_FOUND') {
        Controller = BottomNavbarView

        return Controller
      }

      throw e
    }
  }

  componentDidMount() {
    scripts.concat(Promise.resolve()).reduce((loaded, loading) => {
      return loaded.then((script) => {
        new Function(`
          with (this) {
            eval(arguments[0])
          }
        `).call(window, script)

        return loading
      })
    })
  }

  render() {
    const proxies = Controller !== BottomNavbarView ? transformProxies(this.props.children) : {
      'scan': [],
      'i18n-scan': [],
      'earn': [],
      'i18n-earn': [],
      'wallet': [],
      'i18n-wallet': [],
      'spend': [],
      'i18n-spend': [],
      'rank': [],
      'i18n-rank': [],
    }

    return (
      <span>
        <style dangerouslySetInnerHTML={{ __html: `
          @import url(/css/normalize.css);
          @import url(/css/webflow.css);
          @import url(/css/ecocoin-app.webflow.css);
        ` }} />
        <span className="af-view">
          <div className="af-class-section-2">{map(proxies['scan'], props => <a id="bottomnav-rank-link" href="qr-scan.html" {...{...props, className: `af-class-link-block w-inline-block ${props.className || ''}`}}>{createScope(props.children, proxies => <React.Fragment><img src="/images/Group-7.svg" alt="R" className="af-class-image-5" />{map(proxies['i18n-scan'], props => <h6 {...{...props, className: `af-class-qr-code-big ${props.className || ''}`}}>{props.children ? props.children : <React.Fragment>Scan</React.Fragment>}</h6>)}</React.Fragment>)}</a>)}{map(proxies['earn'], props => <a id="bottomnav-earn-link" href="earn.html" {...{...props, className: `af-class-link-block w-inline-block ${props.className || ''}`}}>{createScope(props.children, proxies => <React.Fragment><img src="/images/Earn-nav-bar-icon.svg" alt="E" className="af-class-image-5" />{map(proxies['i18n-earn'], props => <h6 {...{...props, className: `af-class-qr-code-big ${props.className || ''}`}}>{props.children ? props.children : <React.Fragment>Earn</React.Fragment>}</h6>)}</React.Fragment>)}</a>)}{map(proxies['wallet'], props => <a id="bottomnav-wallet-link" href="wallet.html" {...{...props, className: `af-class-link-block w-inline-block w--current ${props.className || ''}`}}>{createScope(props.children, proxies => <React.Fragment><img src="/images/Wallet-nav-bar-icon.svg" alt="W" className="af-class-image-5" />{map(proxies['i18n-wallet'], props => <h6 {...{...props, className: `af-class-qr-code-big ${props.className || ''}`}}>{props.children ? props.children : <React.Fragment>Wallet</React.Fragment>}</h6>)}</React.Fragment>)}</a>)}{map(proxies['spend'], props => <a id="bottomnav-spend-link" href="spend.html" {...{...props, className: `af-class-link-block w-inline-block ${props.className || ''}`}}>{createScope(props.children, proxies => <React.Fragment><img src="/images/Spend-nav-bar-icon.svg" alt="S" className="af-class-image-5" />{map(proxies['i18n-spend'], props => <h6 {...{...props, className: `af-class-qr-code-big ${props.className || ''}`}}>{props.children ? props.children : <React.Fragment>Spend</React.Fragment>}</h6>)}</React.Fragment>)}</a>)}{map(proxies['rank'], props => <a id="bottomnav-profile-link" href="rank.html" {...{...props, className: `af-class-link-block w-inline-block ${props.className || ''}`}}>{createScope(props.children, proxies => <React.Fragment><img src="/images/Rank.svg" alt="P" className="af-class-image-5" />{map(proxies['i18n-rank'], props => <h6 {...{...props, className: `af-class-qr-code-big ${props.className || ''}`}}>{props.children ? props.children : <React.Fragment>Rank</React.Fragment>}</h6>)}</React.Fragment>)}</a>)}</div>
        </span>
      </span>
    )
  }
}

export default BottomNavbarView

/* eslint-enable */